<div class="shipment-table-container" *ngIf="isShowContainerHeader">
  <div class="shipment-table-container-heading">
    <img src="assets/icons/icon_package_row_white.svg" />
    <h3>{{ container.containerType?.name }}</h3>
  </div>

  <div class="shipment-table-container-info">
    <h5>{{ "LABELS.COSTS" | translate }}</h5>
    <span>{{ totalCostContainer | currency : "USD" : "symbol" : "1.2-2" }}</span>
  </div>

  <div class="shipment-table-container-actions">
    <dropdown-action menuMode="light" *ngIf="isShowDelete">
      <button dropdown-item type="button" class="dropdown-item" (click)="delete.emit()">
        {{ "BUTTON.DELETE" | translate }}
      </button>
    </dropdown-action>
  </div>
</div>

<table class="shipment-table">
  <thead>
    <tr>
      <th *ngIf="isShowCheckbox"></th>

      <th [ngClass]="{ 'p-0': isShowCheckbox }"></th>
      <th></th>

      <th>
        {{ "LABELS.REFERENCE_NUMBER" | translate }}
      </th>

      <th>
        {{ "LABELS.VOLUME" | translate }}
      </th>

      <th>
        {{ "LABELS.WEIGHT" | translate }}
      </th>

      <th>
        {{ "LABELS.PACKAGES_SHORT" | translate }}
      </th>

      <th>
        {{ "LABELS.COST" | translate }}
      </th>

      <th></th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let shipment of shipments">
      <td *ngIf="isShowCheckbox">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            id="shipment-checkbox-{{ container.id }}-{{ shipment.id }}"
            class="custom-control-input"
            [disabled]="isShipmentCanceled(shipment.state)"
            (change)="onCheckboxChecked(shipment.id, $event)"
          />
          <label class="custom-control-label" for="shipment-checkbox-{{ container.id }}-{{ shipment.id }}"><em>.</em></label>
        </div>
      </td>

      <td [ngClass]="{ 'p-0': isShowCheckbox }" class="min-size-cell">
        <div class="shipment-state-icons">
          <img class="shipment-state-icons__arrived" src="assets/icons/icon_house.svg" *ngIf="isShipmentArrived(shipment.trackingState)" />
          <div class="shipment-state-icons__canceled">
            <i *ngIf="isShipmentCanceled(shipment.state)" class="fa fa-ban" aria-hidden="true"></i>
          </div>
        </div>
      </td>
      <td>
        {{ "LABELS." + enumIncotermsType[shipment.incoTermsType] + "_LABEL" | translate }}
      </td>
      <td>
        <a href="" [routerLink]="['/shipments-management', shipment.id]">{{ shipment.referenceNumber }}</a>
      </td>

      <td>{{ shipment.aggregatedStatistics?.realMeasurements?.totalVolume | number : "1.2-2" }}</td>

      <td>{{ shipment.aggregatedStatistics?.realMeasurements?.totalWeight | number : "1.2-2" }}</td>

      <td>{{ shipment.aggregatedStatistics?.totalPackages }}</td>

      <td [ngClass]="{ 'with-opacity': !isShipmentArrived(shipment.trackingState) || isShipmentCanceled(shipment.state) }">
        {{
          (isColoading ? shipment.aggregatedStatistics?.totalCost : shipment.aggregatedStatistics?.containerCost)
            | currency : "USD" : "symbol" : "1.2-2"
        }}
      </td>

      <td class="text-right" class="min-size-cell">
        <dropdown-action menuMode="light" *ngIf="!isShipmentCanceled(shipment.state) && isShipmentMoveable(shipment.trackingState)">
          <button dropdown-item type="button" class="dropdown-item" (click)="moveShipment(shipment.id, shipment.referenceNumber)">
            {{ "LABELS.MOVE" | translate }}
          </button>
        </dropdown-action>
      </td>
    </tr>

    <tr class="shipment-table-empty-list" *ngIf="shipments.length === 0">
      <td colspan="8" class="text-center">
        <h6>{{ "LABELS.EMPTY_SHIPMENTS_LIST" | translate }}</h6>
      </td>
    </tr>
  </tbody>

  <tfoot *ngIf="shipments.length">
    <tr>
      <td *ngIf="isShowCheckbox"></td>

      <td colspan="3">{{ "LABELS.TOTALS_AT_WAREHOUSE" | translate }}:</td>

      <td>{{ totalVolume }}</td>

      <td>{{ totalWeight }}</td>

      <td>{{ totalPackages }}</td>

      <td>{{ totalCost | currency : "USD" : "symbol" : "1.2-2" }}</td>
    </tr>
  </tfoot>
</table>
